// The same CTA is spelled differently in each repo, so Mixpanel splits one
// button into several values. Map known variants onto one label.
// Keys must be lowercase - lookup lowercases the incoming text.
// Keep this table identical in the other repos.
const CTA_TEXT_ALIASES: Record<string, string> = {
  "open account": "Open Account",
  "open an account": "Open Account",
  "open a account": "Open Account",
};

export function normaliseCtaText(text: any): any {
  if (typeof text !== "string") return text;
  const trimmed = text.replace(/\s+/g, " ").trim();
  // exact match only, so "Open a Pro Account" is left alone
  return CTA_TEXT_ALIASES[trimmed.toLowerCase()] || trimmed;
}
